import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderCategories } from "../../../../actions/community/categoriesActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.community.categories.reorderIds);
  const categories = useAppSelector(state => state.community.categories.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderCategories({ ids }));
  }

  return (
    <div className='v-categories-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={categories}
            titleKey='name'
          />
      }
    </div>
  )
}

export default Reorder;
